/* Opt-in debug surface for automated tests: set localStorage "kulaktan.debug" = "1" and the app
   publishes selected state on window.__kulaktan (e.g. the current exercise question). Off by default. */

let enabled: boolean | null = null;

export function debugEnabled(): boolean {
  if (enabled == null) {
    try {
      enabled = typeof localStorage !== 'undefined' && localStorage.getItem('kulaktan.debug') === '1';
    } catch {
      enabled = false;
    }
  }
  return enabled;
}

export function exposeDebug(key: string, value: unknown): void {
  if (!debugEnabled() || typeof window === 'undefined') return;
  const w = window as unknown as { __kulaktan?: Record<string, unknown> };
  w.__kulaktan ??= {};
  w.__kulaktan[key] = value;
}
